// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"940add81","455":"9432b28a","977":"78a1b57f"}[chunkId] + ".chunk.js";
};